import { render, staticRenderFns } from "./ChangeMemberPhonenumber.vue?vue&type=template&id=fa233384&scoped=true&"
import script from "./ChangeMemberPhonenumber.vue?vue&type=script&lang=js&"
export * from "./ChangeMemberPhonenumber.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMemberPhonenumber.vue?vue&type=style&index=0&id=fa233384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa233384",
  null
  
)

export default component.exports